export class UnitConversionUtils {

  static convertFlowRate(currentValue: number, isMetric: boolean): string {
    return (isMetric ? (currentValue * 0.06309) : (currentValue / 0.06309)).toString();
  }

  static convertTemperatureChange(currentValue: number, isMetric: boolean): string {
    return (isMetric ? (currentValue * 0.5556) : (currentValue / 0.5556)).toString();
  }

  static convertTemperatureValue(currentValue: number, isMetric: boolean): string {
    return (isMetric ? ((currentValue - 32.0) * 5.0 / 9.0) : (currentValue * 9.0 / 5.0 + 32.0)).toFixed(1).toString();
  }

  static convertStaticPressure(currentValue: number, isMetric: boolean): string {
    return (isMetric ? (currentValue * 248.84) : (currentValue / 248.84)).toFixed(2).toString();
  }

  static convertAirflow(currentValue: number, isMetric: boolean): string {
    return (isMetric ? currentValue * 0.472 : currentValue / 0.472).toFixed(0).toString();
  }

  static convertAltitudeValue(currentValue: number, isMetric: boolean): string {
    return (isMetric ? (currentValue * 0.3048) : (currentValue / 0.3048)).toFixed(0).toString();
  }

  static convertDimensionalValue(currentValue: number, isMetric: boolean): string {
    return (isMetric ? (currentValue * 2.54) : (currentValue / 2.54)).toString();
  }

  static convertCapacityValue(currentValue: number, isMetric: boolean): string {
    return (isMetric ? (currentValue * .29307) : (currentValue / .29307)).toString();
  }

  static convertWeightValue(currentValue: number, isMetric: boolean): string {
    return (isMetric ? (currentValue * .4535924) : (currentValue / .4535924)).toString();
  }

  static convertSteamPressure(currentValue: number, isMetric: boolean): string {
    return (isMetric ? (currentValue * 6894.757) : (currentValue / 6894.757)).toString();
  }

  static convertFluidVelocity(currentValue: number, isMetric: boolean): string {
    return UnitConversionUtils.convertAltitudeValue(currentValue, isMetric);
  }

  static getFlowRateUnits(isMetric: boolean): string {
    return isMetric ? 'L/s' : 'GPM';
  }

  static getLengthUnits(isMetric: boolean): string {
    return isMetric ? 'Meters' : 'Feet';
  }

  static getAirflowUnits(isMetric: boolean, isStandard = false): string {
    const modifier: string = isStandard ? 'S' : 'A';
    const baseUnits = isMetric ? 'L/s' : 'CFM';
    return modifier + baseUnits;
  }

  static getPressureUnits(isMetric: boolean): string {
    return isMetric ? 'Pa' : 'FtWC';
  }

  static getEspUnits(isMetric: boolean): string {
    return isMetric ? 'Pa' : 'InWC';
  }

  static getCapacityUnits(isMetric: boolean): string {
    return isMetric ? 'Watts' : 'BTUH';
  }

  static getTemperatureUnits(isMetric: boolean): string {
    return isMetric ? '°C' : '°F';
  }

  static getDimensionalUnits(isMetric: boolean): string {
    return isMetric ? 'cm' : 'in';
  }

  static getWeightUnits(isMetric: boolean): string {
    return isMetric ? 'kg' : 'lbs';
  }

  static getSteamPressureUnits(isMetric: boolean): string {
    return isMetric ? 'Pa' : 'PSI';
  }

}
